// Maps the `system_icon` string stored on MerchantItem rows to actual
// lucide-react component classes. Falls back to a generic ShoppingBag
// when the name isn't recognized.
//
// Used by the storefront strip on Landing + the cart-builder + the
// merchant inventory page until S3 image upload (Phase 1.5) lets
// merchants attach real photos.

// lucide-react doesn't ship every food-themed icon you'd want (no Onion,
// no Bean — Sprout/Carrot fill in). Keep the map narrow and well-known;
// anything unmapped falls through to ShoppingBag.
import {
  Wheat, Droplet, Candy, Carrot, EggFried, Utensils, CircleDot,
  Sprout, Banana, CupSoda, Snowflake, Coffee,
  Pill, Beaker, SprayCan, Bandage as BandageIcon,
  ShoppingBag, ShoppingBasket, GraduationCap, Baby, HeartPulse, Soup, Gift,
  type LucideIcon,
} from 'lucide-react';

const MAP: Record<string, LucideIcon> = {
  Wheat, Droplet, Candy, EggFried, Utensils, CircleDot,
  Sprout, Banana, CupSoda, Snowflake, Coffee,
  Pill, Beaker, SprayCan, BandageIcon,
  // Care-package hero icons (CarePackagesSeeder system_icon values).
  ShoppingBasket, GraduationCap, Baby, HeartPulse, Soup, Gift,
  // Friendly fallbacks for seeder names that don't have a direct lucide match.
  Bean: Sprout,
  Onion: Carrot,
};

export function iconFor(name: string | null | undefined): LucideIcon {
  if (!name) return ShoppingBag;
  return MAP[name] ?? ShoppingBag;
}
